import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

type CityLevelUpData = {
    level: number;
};

export class CityLevelUpHandler {
    public handle(data: CityLevelUpData): void {
        ClientEventEmitter.fireEvent(ClientEvents.CITY_LEVEL_UP, data);
    }
}
